var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkGreyBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#393939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.333 46.3333C42.9056 47.0988 43.6362 47.7322 44.4751 48.1906C45.314 48.6489 46.2417 48.9215 47.1952 48.9898C48.1487 49.0581 49.1058 48.9205 50.0015 48.5864C50.8971 48.2523 51.7105 47.7294 52.3863 47.0533L56.3863 43.0533C57.6007 41.796 58.2727 40.112 58.2575 38.364C58.2423 36.616 57.5412 34.9439 56.3051 33.7079C55.0691 32.4718 53.397 31.7707 51.649 31.7555C49.901 31.7403 48.217 32.4123 46.9597 33.6267L44.6663 35.9067",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6669 43.6666C47.0943 42.9011 46.3638 42.2677 45.5249 41.8094C44.6859 41.351 43.7583 41.0785 42.8047 41.0102C41.8512 40.9419 40.8941 41.0795 39.9985 41.4136C39.1028 41.7477 38.2894 42.2705 37.6136 42.9466L33.6136 46.9466C32.3992 48.204 31.7273 49.888 31.7424 51.636C31.7576 53.384 32.4588 55.056 33.6948 56.2921C34.9309 57.5282 36.6029 58.2293 38.3509 58.2445C40.0989 58.2597 41.7829 57.5877 43.0403 56.3733L45.3203 54.0933",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGreyBackground);
export default __webpack_public_path__ + "static/media/linkGreyBackground.8d5a06b5c418bc331a2a70376381071a.svg";
export { ForwardRef as ReactComponent };